<nb-card class="card-box" [nbSpinner]="loading" nbSpinnerStatus="primary">
    <nb-card-header class="content-header">
        <nb-icon class="icon" icon="plus-outline" status="basic"></nb-icon>
        <span class="title__header">{{'common.add-new-device' | translate}}</span>
        <nb-icon icon="question-mark-circle-outline" nbTooltipStatus="control" class="me-2 cursor-help"
                 nbTooltip="{{'tooltips.add-device' | translate}}" nbTooltipPlacement="left"></nb-icon>
        <nb-icon class="close" icon="close-outline" (click)="cancel()"></nb-icon>
    </nb-card-header>
    <ng-container *ngIf="currentStep === 0 && !loading">
        <nb-card-body class="content-body device-list">
            <div class="content-body__info">
                <div class="icon" [style.align-items]="'unset'">
                    <nb-icon icon="alert-circle-outline" status="basic"></nb-icon>
                </div>
                <div class="text">
                    <span [innerHTML]= "(registeredDevices?.length === 0 ? 'errors.4072' : 'device.add-wizard.info') | translate" ></span>
                    <button *ngIf="registeredDevices?.length === 0" (click)="openSupportTab()">https://www.roboze.com</button>
                </div>
            </div>
            <div class="content-body__box" *ngIf="registeredDevices && registeredDevices.length > 0">
                <div class="box__device" *ngFor="let device of registeredDevices">
                    <div class="device__picture">
                        <img src="assets/device/{{device.picture}}">
                    </div>
                    <div class="device__info">
                        <div class="info__modelName">{{device.modelName}}</div>
                        <div class="info__serialNumber">
                            {{'device.details.serial-number' | translate}}:
                            <span class="fw-bold">
                                {{device.serialNumber}}
                            </span>
                        </div>
                    </div>
                    <div class="device__button">
                        <span class="cursor-pointer"
                            (click)="connect(device)">{{'common.add-device' | translate}}</span>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </nb-card-body>
    </ng-container>
    <ng-container *ngIf="currentStep === 1">
        <nb-card-body class="content-body" [style.min-height]="!groupManagementIsAvailable() ? 'unset' : null">
            <form [formGroup]="deviceNameForm">
                <label for="deviceName">{{'device.details.device-name' | translate}}</label>
                <input nbInput fullWidth type="text" id="deviceName" name="deviceName" formControlName="deviceName"
                       required placeholder='{{"common.type-name" | translate}}' [fieldSize]="'large'"
                       [status]="hasError('deviceName') ? 'danger':'primary'" />
                <app-control-messages [control]="getFormControl('deviceName')"></app-control-messages>
                <div class="group-manage-box" *ngIf="groupManagementIsAvailable()">
                    <app-group-manage [deviceId]="selectedDevice.id" (groupCreationMode)='onGroupCreationModeChange($event)'>
                    </app-group-manage>
                </div>
                <label for="deviceDescription" [ngClass]="{'mt-3' : !groupManagementIsAvailable()}">{{'device.details.description' | translate}}: </label>
                <textarea nbInput
                          fullWidth
                          type="text"
                          id="deviceDescription"
                          name="deviceDescription"
                          formControlName="deviceDescription"
                          [fieldSize]="'large'"
                          tabindex="-1"
                          [status]="hasError('deviceDescription') ? 'danger':'primary'">
            </textarea>
                <app-control-messages [control]="getFormControl('deviceDescription')"></app-control-messages>
            </form>
            
        </nb-card-body>
    </ng-container>
    <nb-card-footer class="content-footer">
        <button nbButton [size]="'large'" [status]="'control'" [appearance]="'outline'" class="appearance-outline"
            *ngIf="currentStep === 0" (click)="cancel()">
            {{'common.cancel' | translate}}
        </button>
        <button nbButton [size]="'large'" [status]="'control'" [appearance]="'outline'" class="appearance-outline"
            *ngIf="currentStep === 1" (click)="back()">
            {{'common.back' | translate}}
        </button>
        <button nbButton [status]="'primary'" [size]="'large'" (click)="save()" [disabled]="checkDisabled()"
            *ngIf="currentStep === 1">
            {{(groupCreationModeEnabled ? 'common.create-and-save' : 'common.save') | translate}}
        </button>
    </nb-card-footer>
</nb-card>